import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

fetch('./data/license-data.json')
  .then(res => res.json())
  .then(data => {
    Vue.prototype.$licenseData = data

    new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
  })
